import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledContainer = styled.div`
  width: 100%;
  max-width: 1244px;
  padding: 0 24px;
  margin: 0 auto;

  ${phone(css`
    padding: 0 24px;
  `)}
`
